const LoadingPage = () => {
  return (
    <div className="flex flex-row justify-center align-center h-full">
      <span className="loading loading-spinner text-primary loading-lg"></span>
    </div>
  );
};

export default LoadingPage;
